<template>
  <div class="container text-center leaderboard-wrapper">
    <canvas
      id="firework-canvas"
      v-show="slideActive.type == 'leaderboard' &&
        data.audience && data.audience.totalPoint &&
        data.index == 1 && !showWaitingScreen"
    />
    <div v-if="!showWaitingScreen" class="f-h">
      <div v-if="!isAudienceFormShowing" class="f-h">
        <div v-if="!loading" class="f-h">
          <LeaderBoardHead
            :type="'individual'"
            :data="data"
            :currentQuiz="currentQuiz"
            :titleHTML="leaderboardTitleHTML"
            :presentationID="presentationID"
            :isShowAudiencePacingNextSlide="isShowAudiencePacingNextSlide"
            :lastSlide="lastSlide"
            :isFinalLeaderboard="isFinalLeaderboard"
            :isLoadLastDataLeaderboard="isLoadLastDataLeaderboard"
            @handleClickNextSlide="handleClickNextSlide()"
            v-if="!isRenderLeaderboard"
          />
          <div
            class="audio-control-slide"
            v-if="isAudioControlVisible"
          >
            <AudioControl />
          </div>
          <div v-if="!waitingLeaderboard" class="f-h fix-content-leaderboard">
            <ScoreLeaderboardContent
              type="individual"
              :data="scoreLeaderBoard"
              @nextToWaitingScreen="handleWaitingScreen()"
              :isLoadLastDataLeaderboard="isLoadLastDataLeaderboard"
              v-if="!isRenderLeaderboard"
            />
          </div>
        </div>
        <div v-if="loading" class="horizontal layout center center-justified">
          <Loading />
        </div>
      </div>

      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="getResult()" />
    </div>

    <div v-if="showWaitingScreen && !lastSlide">
      <SlideWaiting />
    </div>
  </div>
</template>
<script>
import * as Sentry from '@sentry/vue'

import Constant from '@/constant'
import utils from '@/util'
import EventBus from '@/eventBus'
import { mapState, mapGetters } from 'vuex'

// UI
import SlideWaiting from '@/components/SlideWaiting.vue'
import Loading from '@/components/Loading.vue'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'

// Utils
import {
  getRankingById,
} from '@/components/utils/leaderboard'

import ScoreLeaderboardContent from '@/components/types/ScoreLeaderboardContent.vue'
import LeaderBoardHead from '@/components/types/LeaderBoardHead.vue'
import SlideApi from '@/api/slide'

export default {
  components: {
    SlideWaiting,
    Loading,
    AudioControl,
    QuizJoinGameForm,
    ScoreLeaderboardContent,
    LeaderBoardHead,
  },
  data() {
    return {
      audienceName: this.$store.state.audienceName,
      data: {},
      leaderboardData: {},
      showWaitingScreen: false,
      myReq: null,
      loading: true,
      waitingLeaderboard: true,
      noResult: false,
      lastSlide: false,
      currentQuiz: null,
      totalQuiz: null,
      countPlayer: 0,
      isLoadLastDataLeaderboard: false,
      urlCacheLeaderboard: null,
      isRenderLeaderboard: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audiencePacing: (state) => state.presentation.audiencePacing,
      presentationID: (state) => state.presentation.id,
      slides: (state) => state.slides,
      presentation: (state) => state.presentation,
      tsRequest: (state) => state.tsRequest,
      isNotWhiteLabel: (state) => {
        return state.presentation.planType !== 'white-label'
      },
      isPresentationLastSlide: (state, getters) => {
        return getters.activeActivity.id === state.presentation.lastSlide
      },
      isFinalLeaderboard: (state, getters) => {
        let isFinalLeaderboard = false
        if (state.slides) {
          const slidesQuiz = state.slides.filter((item) => {
            return item.type === 'pickAnswer'
          })

          const index = state.slides.findIndex((item) => item.id === getters.activeActivity.id)
          let indexQuiz = 0
          if (slidesQuiz.length) {
            indexQuiz = state.slides.findIndex(
              (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
            )
          }
          if (index > indexQuiz) {
            isFinalLeaderboard = true
          }
        }

        return isFinalLeaderboard
      },
      isAudioControlVisible() {
        return (
          this.slideActive
          && this.slideActive.audioLink
          && this.slideActive.audioPlayOnAudience
          && this.slideActive.id
        )
      },
    }),
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    isShowAudiencePacingNextSlide() {
      return !this.isPresentationLastSlide && this.audiencePacing
    },
    isAudienceFormShowing() {
      return !this.$store.state.audienceName || !this.$store.state.isAudienceEmojiDisabled
    },
    getRanking() {
      return getRankingById(this.leaderboardData, this.audienceId)
    },
    isTitleLeaderboardVisible() {
      const { title } = this.slideActive
      return title == null || (title && title.trim().length)
    },
    leaderboardTitleHTML() {
      if (this.slideActive.titleHTML || this.slideActive.title) {
        return this.slideActive.titleHTML || this.slideActive.title
      }

      return this.isFinalLeaderboard
        ? this.$t('final_leaderboard')
        : this.$t('leaderboard')
    },
  },
  destroyed() {
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }

    EventBus.$off('answer-quiz')
  },
  mounted() {
    if (this.$store.state.audienceName) {
      this.getResult()
    } else {
      this.loading = false
    }

    EventBus.$on('answer-quiz', (data) => {
      if (this.$store.state.audienceName && this.waitingLeaderboard) {
        this.handleDataSuccess(data)
      }
    })
    if (this.slideActive.id === this.$store.state.presentation.lastSlide) {
      this.lastSlide = true
    }

    // Firing confetti effect only available if the canvas element is mounted to the DOM
    const canvas = document.getElementById('firework-canvas')
    const colors = Constant.colorsHex.filter((item, key) => {
      return item && key < 7
    })

    this.startConfettiEffect = utils.setupConfettiEffect(canvas, { resize: true },
      {
        startVelocity: 5,
        spread: 360,
        ticks: 100,
        decay: 0.98,
        particleCount: 40,
        shapes: ['circle'],
        colors,
        zIndex: 100,
      })
  },
  methods: {
    handleWaitingScreen() {
      this.showWaitingScreen = true
    },
    _createDataShowListScore(doc) {
      let total = 0
      if (doc.audiences.length) {
        total = doc.audiences[0].t
      }

      doc.audiences.forEach((item, key) => {
        item.color = Constant.colors[key % 30]
        item.oldPercent = (item.t / total) * 100 || 1
      })

      this.scoreLeaderBoard = doc.audiences
      this.countPlayer = doc.audiences.length
    },

    delayTimeRequest(ms) {
      // eslint-disable-next-line promise/avoid-new
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    async asyncLeaderboardAudiencePacing() {
      let data = null
      const slideId = this.slideActive.id
      this.isLoadLastDataLeaderboard = true

      const callApiRequest = async () => {
        if (!this.slideActive.id || slideId !== this.slideActive.id) return null
        const res = await SlideApi.asyncAudienceLeaderboard({
          slideId: this.slideActive.id,
          isFinalLeaderboard: this.isFinalLeaderboard,
        })

        if (res.cacheLeaderboardUrl && !this.urlCacheLeaderboard && res.tsLeaderboard < this.tsRequest) {
          this.urlCacheLeaderboard = res.cacheLeaderboardUrl
          this.handleDataResponseLeaderboard(this.urlCacheLeaderboard, false)
        }

        if (!this.tsRequest) {
          this.$store.state.tsRequest = res.tsRequest
        }
        if (!res.cacheLeaderboardUrl || res.tsLeaderboard < this.tsRequest) {
          await this.delayTimeRequest(2000)
          return callApiRequest()
        }
        data = res
        this.isLoadLastDataLeaderboard = false
        return res
      }

      await callApiRequest()
      return data
    },

    async handleDataResponseLeaderboard(url, isRenderLeaderboard) {
      const res = await this.$http.get(url)
      const doc = res.body
      this.loading = false

      if (!doc.id) {
        doc.audiences = []
      }
      if (!doc.audiences.length) {
        this.noResult = true
        return
      }
      this.handleDataSuccess(doc)
      this.currentQuiz = doc.currentQuiz
      this.totalQuiz = doc.totalQuiz
      this._createDataShowListScore(doc)
      if (isRenderLeaderboard) {
        this.isRenderLeaderboard = true
        setTimeout(() => {
          this.isRenderLeaderboard = false
        }, 500)
      }
    },

    async getResult() {
      this.loading = true

      try {
        let url = this.slideActive.cacheLeaderboardUrl
        let isRenderLeaderboard = false
        if (this.presentation.audiencePacing) {
          this.tsRequest = null
          const res = await this.asyncLeaderboardAudiencePacing()
          if (res) {
            url = res.cacheLeaderboardUrl
            isRenderLeaderboard = true
          }
        }
        if (!url) {
          this.loading = false
          this.noResult = true
          return
        }
        await this.handleDataResponseLeaderboard(url, isRenderLeaderboard)
      } catch (err) {
        this.noResult = true
        this.loading = false
        Sentry.captureException(err)
      }
    },

    handleDataSuccess(doc) {
      if (!doc.id || doc.loading) {
        this.waitingLeaderboard = true
        return
      }

      this.leaderboardData = doc
      this.waitingLeaderboard = false
      const index = doc.audiences.findIndex((item) => {
        return item.a === this.audienceId
      })

      if (index === -1) {
        this.data.totalQuiz = utils.numberWithCommas(doc.totalQuiz)
      }

      if (index !== -1) {
        const audience = doc.audiences[index]
        this.data.audience = {
          audience: this.audienceId,
          audienceEmoji: this.$store.state.audienceEmoji,
          audienceName: this.$store.state.audienceName,
          index: audience.i,
          totalPoint: audience.t,
          correctRate: audience.cR || 0,
          correctAnswerCount: audience.cAc || 0,
        }
        this.data.index = audience.i
        this.data.audience.totalPoint = utils.numberWithCommas(this.data.audience.totalPoint)
        this.data.indexFormat = utils.numberWithCommas(audience.i)
        this.data.totalQuiz = utils.numberWithCommas(doc.totalQuiz)
      }
      this.data.lastSlide = doc.lastSlide
      this.data.audienceCount = doc.audiences.length
      this.data.audiencesCount = utils.numberWithCommas(doc.audiences.length)
      if (this.data.lastSlide) {
        this.slideActive.finalLeaderboard = true
      }

      if (
        this.isFinalLeaderboard &&
        this.data.audience &&
        this.data.audience.totalPoint &&
        this.data.index === 1
      ) {
        const self = this
        if (!self.startConfettiEffect) {
          return
        }

        let start = null

        // eslint-disable-next-line
        function step(timestamp) {
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > 1200) {
            start = null
            self.startConfettiEffect({
              x: Math.random(),
              y: Math.random() - 0.3,
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
    },

    handleClickOnButtonCTA() {
      window.open(utils.generateButtonCTAURL(this.presentationID, this.slideActive, 'leaderboard_CTA'), '_blank')
      utils.trackGAButtonCTA(this.presentationID, this.slideActive)
    },

    handleClickNextSlide() {
      EventBus.$emit('skipSlide')
    },
  },
}
</script>
<style lang="scss">
.fix-content-leaderboard {
  .button-next-wrapper {
    margin-top: 4px;
    margin-bottom: 4px;
  }
}

.point-audience {
  margin-bottom: 16px;
}
</style>
